import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetricFormats } from '../../../../../modules/reporting/drilldown-reports/enums/metric-formats.enum';

@Component({
  selector: 'gtd-terms-format',
  templateUrl: './terms-format.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsFormatComponent {
  @Input() customClass = 'justify-content-end';
  @Input() data: { format: string; value: any };
  @Input() currencyCode: string | undefined;
  @Input() field: string = 'value';

  public formats = MetricFormats;

  public getFormat(format: string): string {
    if (format === this.formats.MONEY_PAYOUT || format === this.formats.MONEY_REVENUE) {
      return this.formats.MONEY;
    }
    if (format === this.formats.PERCENT) {
      return this.formats.PERCENTAGE;
    }
    return format;
  }
}
